import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo(() => {
  return (
    <WelcomeScreen>
      <WelcomeScreen.Center>
        <img
          src="/logo_ineo_space.png"
          alt="Ineo Space"
          style={{ maxWidth: 320, width: "100%", height: "auto" }}
        />
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
